import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import ModalWindow from "../../../UI/ModalWindow";
import TemplateModal from "./TemplateModal";

const TemplateCard = ({ url, name }) => {
  const [templateModal, setTemplateModal] = useState(false);

  return (
    <div className="a4-tile" onClick={() => setTemplateModal((prev) => !prev)}>
      <iframe className="a4-iframe" src={url} sandbox="allow-same-origin" />
      <p className="template-name">{name}</p>
      <div className="eye-hover">
        <FontAwesomeIcon size="2xl" color="white" icon={faEye} />
      </div>
      <ModalWindow
        modalClass={"a4-template-modal"}
        size="lg"
        modalHeader={name}
        toggleModal={() => setTemplateModal((prev) => !prev)}
        modal={templateModal}
        modalBody={<TemplateModal url={url} />}
      />
    </div>
  );
};

export default TemplateCard;
